import {ServicesConfigurationsWithIdSchema} from "@feature/types";
import {DATA_TRANSFER_ALLOWED_TYPES} from "@feature/services/associate-services-logic/lib/consts";

export const isDesignOutputSelectable = (
  questionType: string | undefined,
  output: ServicesConfigurationsWithIdSchema,
  serviceConfigurations: ServicesConfigurationsWithIdSchema[],
) => {

  if (!questionType || !DATA_TRANSFER_ALLOWED_TYPES.includes(questionType))
    // Only allow data transfer for number, text, and boolean inputs
    return false;

  if (output.output_type === "json_output_value")
    // JSON value can be anything, so it must be allowed
    return true;

  if (output.output_type === "calculation" && questionType === "number_input")
    // Allow calculation values for number inputs
    return true;

  if (output.output_type !== "question")
    // If at this point the output type is not a question value, it is not allowed
    return false;

  const outputQuestion = serviceConfigurations
    .find(q => q.id === output.output_input_id);
  if (!outputQuestion)
    // If the output question does not exist, it is not allowed
    return false;

  // Allow data transfer if the output question is the same type as the input question
  return outputQuestion.input_type === questionType
    || (["node_reinforcement_input", "connector_input"].includes(outputQuestion.input_type || ""));
}